// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"cda556b9","239":"161bfc95","453":"4dd2a027","455":"64a2be4a","977":"130d6061"}[chunkId] + ".chunk.js";
};